// Local translations
export const T = {
  en_GB: {
    pageTitle: "Clients",
    pageDescription: "Manage your clients here",
    documentation: "Documentation",
    selectView: "Select view",
    default: "Default",
    searchPlaceholder: "Search clients...",
    addClient: "Add Client",
    noFavourites: "No favourite clients. Star a client to see it here.",
    noMatchingClients: "No clients match this view.",
    noSearchResults: "No clients match your search.",
  },
  nb_NO: {
    pageTitle: "Kunder",
    pageDescription: "Administrer kundene dine her",
    documentation: "Dokumentasjon",
    selectView: "Velg visning",
    default: "Standard",
    searchPlaceholder: "Søk etter kunder...",
    addClient: "Legg til kunde",
    noFavourites: "Ingen favorittkunder. Merk en kunde med stjerne for å se den her.",
    noMatchingClients: "Ingen kunder samsvarer med denne visningen.",
    noSearchResults: "Ingen kunder samsvarer med søket ditt.",
  },
} as const;
